async function loadFont(url) {
    try {
        let response = await fetch(url);
        if (!response.ok) return null;
        let buffer = await response.arrayBuffer();
        return opentype.parse(buffer);
    } catch (error) {
        console.error("Fehler beim Laden der Schrift:", error);
        return null;
    }
}

/**
 * Holt die aktuell gewählte Schriftart-URL.
 * Quelle:
 *  - Hidden-Input .wunschtext-line-font-input (z.B. value="Anton")
 *  - Zuordnung über <select id="font-select"> und data-font
 */
function getSelectedFont() {
    const fontSelect = document.getElementById('font-select');
    if (!fontSelect) {
        console.error('font-select nicht gefunden');
        return null;
    }

    // Versuche zuerst den Wert aus dem Hidden-Input (dein dynamisches Select)
    const fontInput = document.querySelector('.wunschtext-line-font-input');
    let selectedValue = fontInput ? fontInput.value : null;

    // Fallback: aktueller Wert im font-select
    if (!selectedValue) {
        selectedValue = fontSelect.value;
    }

    // Fallback: erste Option
    if (!selectedValue && fontSelect.options.length > 0) {
        selectedValue = fontSelect.options[0].value;
    }

    if (!selectedValue) {
        console.error('Keine Schriftart ausgewählt');
        return null;
    }

    // Passende Option im font-select finden
    let matchedOption = null;
    for (const opt of fontSelect.options) {
        if (opt.value === selectedValue) {
            matchedOption = opt;
            break;
        }
    }

    // Wenn nichts gefunden, nimm erste Option
    if (!matchedOption && fontSelect.options.length > 0) {
        matchedOption = fontSelect.options[0];
    }

    if (!matchedOption) {
        console.error('Keine passende Option im font-select gefunden');
        return null;
    }

    const fontUrl = matchedOption.getAttribute('data-font');
    if (!fontUrl) {
        console.error('data-font auf Option nicht gesetzt');
    }
    return fontUrl || null;
}

/**
 * Holt die aktuell gewählte Folienfarbe aus
 * <input class="wunschtext-line-color-input" value="#xxxxxx">
 */
function getSelectedColor() {
    const colorInput = document.querySelector('.wunschtext-line-color-input');
    const val = colorInput ? colorInput.value : null;
    // Simple Hex-Check, sonst Fallback Schwarz
    if (val && /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(val)) {
        return val;
    }
    return "#000000";
}

// Definition der Select-Liste zu SVG-Output Zuordnungen
const selectToSvgMap = [
    { selectName: "properties[Zeit-1]", svgId: "svg-Output-1", x: "75px", y: "212px" },
    { selectName: "properties[Zeit-2]", svgId: "svg-Output-2", x: "225px", y: "212px" },
    { selectName: "properties[Zeit-3]", svgId: "svg-Output-3", x: "75px", y: "262px" },
    { selectName: "properties[Zeit-4]", svgId: "svg-Output-4", x: "225px", y: "262px" },
    { selectName: "properties[Zeit-5]", svgId: "svg-Output-5", x: "75px", y: "312px" },
    { selectName: "properties[Zeit-6]", svgId: "svg-Output-6", x: "225px", y: "312px" },
    { selectName: "properties[Zeit-7]", svgId: "svg-Output-7", x: "225px", y: "312px" },
    { selectName: "properties[Zeit-8]", svgId: "svg-Output-8", x: "225px", y: "312px" },
    { selectName: "properties[Zeit-9]", svgId: "svg-Output-9", x: "225px", y: "312px" },
    { selectName: "properties[Zeit-10]", svgId: "svg-Output-10", x: "225px", y: "312px" },
    { selectName: "properties[Zeit-11]", svgId: "svg-Output-11", x: "225px", y: "312px" },
    { selectName: "properties[Zeit-12]", svgId: "svg-Output-12", x: "225px", y: "312px" },
    { selectName: "properties[Zeit-13]", svgId: "svg-Output-13", x: "225px", y: "312px" },
    { selectName: "properties[Zeit-14]", svgId: "svg-Output-14", x: "225px", y: "312px" }
];

// Funktion zum Erstellen der SVG-Outputs, aber nur für vorhandene Select-Listen
function createSvgOutputs() {
    const svgPrint = document.getElementById("svg-print");
    
    if (!svgPrint) {
        console.error("svg-print Element nicht gefunden");
        return;
    }
    
    // Erstelle SVG-Outputs nur für vorhandene Select-Listen
    selectToSvgMap.forEach(mapping => {
        // Prüfe, ob die entsprechende Select-Liste existiert
        const select = document.querySelector(`select[name="${mapping.selectName}"]`);
        
        if (select && !document.getElementById(mapping.svgId)) {
            const svgOutput = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svgOutput.setAttribute("id", mapping.svgId);
            svgOutput.setAttribute("x", mapping.x);
            svgOutput.setAttribute("y", mapping.y);
            svgPrint.appendChild(svgOutput);
        }
    });
}

/**
 * Färbt alle Elemente im #svg-path auf die aktuell gewählte Folienfarbe um
 */
function updateSvgPathColor() {
    const svgPath = document.getElementById("svg-path");
    if (!svgPath) return;

    const color = getSelectedColor();

    const elements = svgPath.querySelectorAll('*');
    elements.forEach(el => {
        const tag = el.tagName.toLowerCase();

        // Alle relevanten Shapes einfärben
        if (
            tag === 'path'  ||
            tag === 'rect'  ||
            tag === 'circle' ||
            tag === 'ellipse' ||
            tag === 'polygon' ||
            tag === 'polyline'
        ) {
            el.setAttribute('fill', color);
        }
    });
}


// Hauptfunktion zum Generieren eines SVGs
async function generateSVG(selectName) {
    // Finde die entsprechende Zuordnung
    const mapping = selectToSvgMap.find(item => item.selectName === selectName);
    if (!mapping) {
        console.error(`Keine Zuordnung für Select-Liste ${selectName} gefunden`);
        return;
    }
    
    // Hole den Wert aus der Select-Liste
    const select = document.querySelector(`select[name="${selectName}"]`);
    if (!select) {
        console.error(`Select-Liste ${selectName} nicht gefunden`);
        return;
    }
    
    const text = select.value;
    
    // Hole das SVG-Output Element oder erstelle es, falls es noch nicht existiert
    let svgOutput = document.getElementById(mapping.svgId);
    if (!svgOutput) {
        const svgPrint = document.getElementById("svg-print");
        if (!svgPrint) {
            console.error("svg-print Element nicht gefunden");
            return;
        }
        
        svgOutput = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svgOutput.setAttribute("id", mapping.svgId);
        svgOutput.setAttribute("x", mapping.x);
        svgOutput.setAttribute("y", mapping.y);
        svgPrint.appendChild(svgOutput);
    }
    
    // Schriftart holen
    const fontUrl = getSelectedFont();
    if (!fontUrl) {
        console.error("Keine Schriftart gefunden");
        return;
    }
    
    const font = await loadFont(fontUrl);
    if (!font) return;

    // Schriftgrösse aus hidden Feld base_font_size
    const baseFontInput = document.getElementById("base_font_size");
    const fontSize = parseInt(baseFontInput?.value) || 80;
    
    // Farbe aus Folienfarb-Input
    const textColor = getSelectedColor();
    
    const lines = text.split("\n");
    const lineHeightFactor = 1;
    
    // Variablen zum Berechnen der Gesamtbegrenzung
    let overallMinX = Infinity;
    let overallMinY = Infinity;
    let overallMaxX = -Infinity;
    let overallMaxY = -Infinity;
    
    let svgContent = "";
    let y = 0;
    
    lines.forEach(line => {
        const path = font.getPath(line, 0, y, fontSize);
        const bbox = path.getBoundingBox();
        
        overallMinX = Math.min(overallMinX, bbox.x1);
        overallMinY = Math.min(overallMinY, bbox.y1);
        overallMaxX = Math.max(overallMaxX, bbox.x2);
        overallMaxY = Math.max(overallMaxY, bbox.y2);
        
        svgContent += `<path d='${path.toPathData()}' fill='${textColor}'/>`;
        y += fontSize * lineHeightFactor;
    });
    
    // Breite und Höhe aus dem gesamten Bounding Box berechnen
    const width = overallMaxX - overallMinX;
    const height = overallMaxY - overallMinY;
    
    // Gruppentranslation: Verschiebe so, dass der kleinste Punkt bei (0,0) liegt
    const translateX = -overallMinX;
    const translateY = -overallMinY;
    
    const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 ${width} ${height}'>
                <g transform='translate(${translateX},${translateY})'>${svgContent}</g>
              </svg>`;
    
    svgOutput.innerHTML = svg;
    svgOutput.setAttribute("width", width);
    svgOutput.setAttribute("height", height);
    
    updateSVGContainer();
}

// Funktion, die alle SVGs für vorhandene Select-Listen neu generiert
async function generateAllSVGs() {
    for (const mapping of selectToSvgMap) {
        const select = document.querySelector(`select[name="${mapping.selectName}"]`);
        if (select) {
            await generateSVG(mapping.selectName);
        }
    }
    // Nach dem Neu-Rendern auch den svg-path einfärben
    updateSvgPathColor();
}

function updateSVGContainer() {
    const svgPrint = document.getElementById("svg-print");
    if (!svgPrint) return;
    
    // Sammle alle Dimensionen der SVG-Outputs
    let maxWidth = 0;
    let maxHeight = 0;
    
    // Betrachte nur die SVG-Outputs, die tatsächlich existieren
    selectToSvgMap.forEach(mapping => {
        const svgOutput = document.getElementById(mapping.svgId);
        if (!svgOutput) return;
        
        const outputWidth = parseFloat(svgOutput.getAttribute("width")) || 0;
        const outputHeight = parseFloat(svgOutput.getAttribute("height")) || 0;
        const outputX = parseFloat(svgOutput.getAttribute("x")) || 0;
        const outputY = parseFloat(svgOutput.getAttribute("y")) || 0;
        
        maxWidth = Math.max(maxWidth, outputWidth + outputX);
        maxHeight = Math.max(maxHeight, outputHeight + outputY);
    });
    
    // Berücksichtige auch das svg-path Element, falls vorhanden
    const svgPath = document.getElementById("svg-path");
    if (svgPath) {
        const pathWidth = parseFloat(svgPath.getAttribute("width")) || 0;
        const pathHeight = parseFloat(svgPath.getAttribute("height")) || 0;
        const pathX = parseFloat(svgPath.getAttribute("x")) || 0;
        const pathY = parseFloat(svgPath.getAttribute("y")) || 0;
        
        maxWidth = Math.max(maxWidth, pathWidth + pathX);
        maxHeight = Math.max(maxHeight, pathHeight + pathY);
    }
    
    svgPrint.setAttribute("width", maxWidth);
    svgPrint.setAttribute("height", maxHeight);
}

// Event-Listener bei DOM-Laden
document.addEventListener('DOMContentLoaded', function() {
    // Erstelle die SVG-Outputs nur für vorhandene Select-Listen
    createSvgOutputs();
    
    // Schriftartwechsel: wenn dein dynamisches Select den Hidden-Input ändert
    const fontInput = document.querySelector('.wunschtext-line-font-input');
    if (fontInput) {
        fontInput.addEventListener('change', function() {
            generateAllSVGs();
        });
    }

    // Optional: falls du mal direkt im versteckten <select id="font-select"> änderst
    const fontSelect = document.getElementById('font-select');
    if (fontSelect) {
        fontSelect.addEventListener('change', function() {
            generateAllSVGs();
        });
    }
    
    // Event-Listener für alle vorhandenen Select-Listen
    selectToSvgMap.forEach(mapping => {
        const select = document.querySelector(`select[name="${mapping.selectName}"]`);
        if (select) {
            select.addEventListener('change', function() {
                generateSVG(mapping.selectName);
            });
        }
    });
    
    // Event-Listener für Schriftgrösse aus base_font_size
    const baseFontInput = document.getElementById("base_font_size");
    if (baseFontInput) {
        baseFontInput.addEventListener("change", generateAllSVGs);
    }

    // Event-Listener für Folienfarbe (Hidden-Input)
    const colorInput = document.querySelector('.wunschtext-line-color-input');
    if (colorInput) {
        colorInput.addEventListener('change', function() {
            generateAllSVGs();      // Text neu färben
            updateSvgPathColor();   // svg-path einfärben
        });
    }
    
    // Initiale Generierung der SVGs
    generateAllSVGs();
    
    // Optional: Beobachte DOM-Änderungen, falls Select-Listen dynamisch hinzugefügt werden
    const observer = new MutationObserver(function(mutations) {
        let newSelectsAdded = false;
        
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        const newSelects = node.querySelectorAll ? 
                            Array.from(node.querySelectorAll('select')).filter(select => {
                                const name = select.getAttribute('name');
                                return name && selectToSvgMap.some(mapping => mapping.selectName === name);
                            }) : [];
                        
                        if (newSelects.length > 0) {
                            newSelectsAdded = true;
                        }
                    }
                });
            }
        });
        
        if (newSelectsAdded) {
            createSvgOutputs();
            
            selectToSvgMap.forEach(mapping => {
                const select = document.querySelector(`select[name="${mapping.selectName}"]`);
                if (select && !select.hasEventListener) {
                    select.hasEventListener = true;
                    select.addEventListener('change', function() {
                        generateSVG(mapping.selectName);
                    });
                }
            });
            
            generateAllSVGs();
        }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
});
